module.exports = __webpack_public_path__ + "static/img/tab-banner1.ed65b0a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/7/tab-banner1.png
// module id = 2a2+
// module chunks = 1